import { type ReactNode } from 'react'
import NextLink from 'next/link'
import { Link as NuiLink } from '@theneatcompany/nui' // eslint-disable-line no-restricted-imports
import type { LinkProps as NuiLinkProps } from '@theneatcompany/nui'

import { getMessage } from '@/utils/messages'
import type { MessageId, MessageProps } from '@/translations/messages'

export type LinkProps = Omit<NuiLinkProps, 'children'> & {
  children?: ReactNode
  messageProps?: MessageProps
  messageId?: MessageId
}

export default function Link({ children, to, messageProps = {}, messageId = messageProps.id, ...props }: LinkProps) {
  const renderChildren = () => {
    if (messageId) return getMessage(messageId, messageProps.values)
    return children || <></>
  }
  return (
    <NextLink href={to} {...props} passHref legacyBehavior>
      <NuiLink {...props} to={to}>
        {renderChildren()}
      </NuiLink>
    </NextLink>
  )
}
